import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const logPoint = defineConnector({
  identifier: "logPoint",
  name: "LogPoint",
  tagLine: "Security operations and analytics",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://logpoint\\.example\\.com/.*",
  auth: customAuth("logPoint"),
  steps: [
    {
      title: "Collect your Logpoint username and secret key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.logpoint.com/docs/logpoint-api-reference/en/latest/index.html](https://docs.logpoint.com/docs/logpoint-api-reference/en/latest/index.html) and [https://docs.logpoint.com/siem/product-docs/readme/siem_api_reference/search-api](https://docs.logpoint.com/siem/product-docs/readme/siem_api_reference/search-api). Logpoint's Search API requires `username` and `secret_key` in an `application/x-www-form-urlencoded` request body.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "LogPoint base URL",
          placeholder: "https://logpoint.example.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: {
            kind: "secrets",
            field: "username",
          },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: {
            kind: "secrets",
            field: "secretKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://logpoint.example.com/getalloweddata",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/getalloweddata`)(configuration),
      method: testMethod === "GET" ? "GET" : "POST",
      body: "type=user_preference",
    }),
  },
});
